// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
// import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

// // type Props = {
// //   className: string
// //   x_axis?: any
// //   y_axis?: any
// // }

// type Props = {
//   className: string
//   x_axis?: any
//   y_axis?: any
//   title?: string
//   series1Name?: string
//   series2Name?: string
//   data?: any
// }

// const ChartsWidget2: React.FC<Props> = ({
//   className,
//   x_axis,
//   y_axis,
//   title = "PO Vs Dispatch",
//   series1Name = "Net Profit",
//   series2Name = "Revenue",
//   data
// }) => {




//   // console.log("admin gdata", data?.detailsForMonth)


















//   // Get the monthly details from your data
//   const details = data?.detailsForMonth || {};


//   // Define months in order (April to March)
//   const monthsInOrder = [
//     '2025-04', '2025-05', '2025-06', '2025-07',
//     '2025-08', '2025-09', '2025-10', '2025-11',
//     '2025-12', '2026-01', '2026-02', '2026-03'
//   ];

//   // Extract gross margin values
//   const grossMargin = monthsInOrder.map((month) => {
//     // Access the grossMargin value for this month
//     const val = details[month]?.grossMargin;
//     // If it's a valid number, use it, otherwise use 0
//     return typeof val === 'number' && !isNaN(val) ? val : 0;
//   });

//   // Extract gross margin percentage values
//   const grossMarginPercentage = monthsInOrder.map((month) => {
//     // Access the grossMarginPercentage value for this month
//     const val = details[month]?.grossMarginPercentage;
//     // Convert string to number if needed
//     const num = typeof val === 'number' ? val * 100 : parseFloat(val) * 100;
//     // If it's a valid number, format it to 3 decimal places, otherwise use 0
//     return !isNaN(num) ? Number(num.toFixed(2)) : 0;
//   });

//   // Now create your chart series
//   const chartSeries = [
//     {
//       name: 'Gross Margin',
//       data: grossMargin
//     },
//     {
//       name: 'Gross Margin Percentage',
//       data: grossMarginPercentage
//     }
//   ];

//   // Print to check values
//   console.log("Gross Margin Values:", grossMargin);
//   console.log("Gross Margin Percentage Values:", grossMarginPercentage);















//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const { mode } = useThemeMode()

//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const height = parseInt(getCSS(chartRef.current, 'height'))

//     const chart = new ApexCharts(chartRef.current, getChartOptions(height, x_axis, y_axis))
//     if (chart) {
//       chart.render()
//     }

//     return chart
//   }

//   useEffect(() => {
//     const chart = refreshChart()
//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
//   }, [chartRef, mode, x_axis, y_axis])

//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Header */}
//       <div className='card-header border-0 pt-5'>
//         <h3 className='card-title align-items-start flex-column'>
//           <span className='card-label fw-bold fs-3 mb-1'>{title}</span>

//           {/* <span className='text-muted fw-semibold fs-7'>More than 500 new orders</span> */}
//         </h3>

//         {/* begin::Toolbar */}
//         {/*  <div className='card-toolbar' data-kt-buttons='true'>
//           <a
//             className='btn btn-sm btn-color-muted btn-active btn-active-primary active px-4 me-1'
//             id='kt_charts_widget_2_year_btn'
//           >
//             Year
//           </a>

//           <a
//             className='btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1'
//             id='kt_charts_widget_2_month_btn'
//           >
//             Month
//           </a>

//           <a
//             className='btn btn-sm btn-color-muted btn-active btn-active-primary px-4'
//             id='kt_charts_widget_2_week_btn'
//           >
//             Week
//           </a>
//         </div> */}
//         {/* end::Toolbar */}
//       </div>
//       {/* end::Header */}

//       {/* begin::Body */}
//       <div className='card-body'>
//         {/* begin::Chart */}
//         <div ref={chartRef} id='kt_charts_widget_2_chart' style={{ height: '350px' }}></div>
//         {/* end::Chart */}
//       </div>
//       {/* end::Body */}
//     </div>
//   )
// }

// export { ChartsWidget2 }

// function getChartOptions(height: number, x_axis: any, y_axis): ApexOptions {
//   const labelColor = getCSSVariableValue('--bs-gray-500')
//   const borderColor = getCSSVariableValue('--bs-gray-200')
//   // const baseColor = getCSSVariableValue('--bs-warning')
//   const baseColor = '#1b83ff'  // Changed from warning to specific blue color
//   const secondaryColor = getCSSVariableValue('--bs-gray-300')
//   return {
//     series: y_axis || [
//       {
//         name: 'Net Profit',
//         data: [44, 55, 57, 56, 61, 58, 62, 63, 59, 65, 61, 68],
//       },
//       {
//         name: 'Revenue',
//         data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 110, 98, 112],
//       },
//     ],
//     chart: {
//       fontFamily: 'inherit',
//       type: 'bar',
//       height: height,
//       toolbar: {
//         show: false,
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: false,
//         columnWidth: '40%',
//         borderRadius: 5,
//       },
//     },
//     legend: {
//       show: true,
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     stroke: {
//       show: true,
//       width: 2,
//       colors: ['transparent'],
//     },
//     xaxis: {
//       // categories: x_axis || [],
//       categories: x_axis || ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//       labels: {
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//     },
//     yaxis: {
//       labels: {
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//     },
//     fill: {
//       opacity: 1,
//     },
//     states: {
//       normal: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       hover: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       active: {
//         allowMultipleDataPointsSelection: false,
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//     },
//     tooltip: {
//       style: {
//         fontSize: '12px',
//       },
//       y: {
//         formatter: function (val: any) {
//           return val + ' KG'
//         },
//       },
//     },
//     colors: [baseColor, secondaryColor, labelColor, '#1034A6'],
//     grid: {
//       borderColor: borderColor,
//       strokeDashArray: 4,
//       yaxis: {
//         lines: {
//           show: true,
//         },
//       },
//     },
//   }
// }



/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
  x_axis?: any
  y_axis?: any
  title?: string
  series1Name?: string
  series2Name?: string
  data?: any
}

const ChartsWidget2: React.FC<Props> = ({
  className,
  x_axis,
  y_axis,
  title = "PO Vs Dispatch",
  series1Name = "Net Profit",
  series2Name = "Revenue",
  data
}) => {
  // Get the monthly details from your data
  const details = data?.detailsForMonth || {};

  // Define months in order (April to March)
  const monthsInOrder = Object?.keys(data?.detailsForMonth || {})
  // const monthsInOrder = [
  //   '2025-04', '2025-05', '2025-06', '2025-07',
  //   '2025-08', '2025-09', '2025-10', '2025-11',
  //   '2025-12', '2026-01', '2026-02', '2026-03'
  // ];

  // Month names for display
  const monthNames = monthsInOrder?.map((month) => {
    const date = new Date(month)
    const monthName = date.toLocaleString('default', { month: 'short' })
    return monthName
  })
  // const monthNames = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];

  // Extract gross margin values
  const grossMargin = monthsInOrder.map((month) => {
    // Access the grossMargin value for this month
    const val = details[month]?.grossMargin;
    // If it's a valid number, use it, otherwise use 0
    return typeof val === 'number' && !isNaN(val) ? val : 0;
  });

  // Extract gross margin percentage values
  const grossMarginPercentage = monthsInOrder.map((month) => {
    // Access the grossMarginPercentage value for this month
    const val = details[month]?.grossMarginPercentage;
    // Convert string to number if needed, handle "NaN" case
    if (val === "NaN") return 0;
    // const num = typeof val === 'number' ? val * 100 : parseFloat(val) * 100;
    const num = typeof val === 'number' ? val : parseFloat(val);
    // If it's a valid number, format it to 2 decimal places, otherwise use 0
    return !isNaN(num) ? Number(num.toFixed(2)) : 0;
  });

  // Print for debugging
  console.log("Gross Margin Values:", grossMargin);
  console.log("Gross Margin Percentage Values:", grossMarginPercentage);

  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    // Pass the variables directly to getChartOptions
    const chart = new ApexCharts(
      chartRef.current,
      getChartOptions(
        height,
        monthNames,
        grossMargin,
        grossMarginPercentage,
        series1Name,
        series2Name
      )
    )

    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, data, series1Name, series2Name])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{title}</span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        <div ref={chartRef} id='kt_charts_widget_2_chart' style={{ height: '350px' }}></div>
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { ChartsWidget2 }

// Updated function signature to accept grossMargin and grossMarginPercentage directly
function getChartOptions(
  height: number,
  categories: string[],
  grossMargin: number[],
  grossMarginPercentage: number[],
  series1Name: string = "Gross Margin ",
  series2Name: string = "Gross Margin Percentage"
): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-900')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = '#1b83ff'  // Changed from warning to specific blue color
  const secondaryColor = getCSSVariableValue('--bs-gray-300')

  return {
    series: [
      {
        name: series1Name,
        data: grossMarginPercentage,
      },
      {
        name: series2Name,
        data: grossMargin,
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        borderRadius: 5,
      },
    },
    legend: {
      show: true,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
        formatter: function (val) {
          return val.toFixed(2);
        }
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val: any) {
          return val?.toLocaleString('en-IN')
        },
      },
    },
    colors: [baseColor, secondaryColor, labelColor, '#1034A6'],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}
